import QuotationPage from "./components/quatation-Form-view";

export default function SendOffert() {
  return (
    <div
      className="flex flex-col min-h-screen"
      style={{ background: "#f8fafa !important" }}
    >
      <div className="xs:flex xs:flex-col  items-center">
        <main className="flex min-h-screen items-center  w-full  flex-col">
          <section className="w-full bg-primary-white p-5 rounded-md  py-6">
            <QuotationPage />
          </section>
        </main>
      </div>
    </div>
  );
}
